// import React from "react";
// import {
//   Paper,
//   Typography,
//   List,
//   ListItem,
//   ListItemText,
//   Box,
//   Divider,
// } from "@mui/material";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

// export default function InterviewCalendarWidget({ events = [] }) {
//   const hasEvents = Array.isArray(events) && events.length > 0;

//   const formatEventDate = (start, end) => {
//     const startDate = new Date(start);
//     const endDate = new Date(end);

//     const sameDay =
//       startDate.toDateString() === endDate.toDateString();

//     const dateLabel = startDate.toLocaleDateString(undefined, {
//       weekday: "short",
//       month: "short",
//       day: "numeric",
//     });

//     if (!sameDay) {
//       return `${startDate.toLocaleString()} – ${endDate.toLocaleString()}`;
//     }

//     const timeRange = `${startDate.toLocaleTimeString([], {
//       hour: "2-digit",
//       minute: "2-digit",
//     })} – ${endDate.toLocaleTimeString([], {
//       hour: "2-digit",
//       minute: "2-digit",
//     })}`;

//     return { dateLabel, timeRange };
//   };

//   return (
//     <Paper
//       elevation={0}
//       sx={{
//         p: 2.5,
//         mb: 3,
//         borderRadius: 2,
//         bgcolor: "#ffffff",
//         boxShadow: "0 8px 24px rgba(15,23,42,0.10)",
//         display: "flex",
//         flexDirection: "column",
//         height: "100%",
//       }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           mb: 1.5,
//           display: "flex",
//           alignItems: { xs: "flex-start", sm: "center" },
//           justifyContent: "space-between",
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <Box>
//           <Typography
//             variant="overline"
//             sx={{
//               fontSize: 11,
//               letterSpacing: 0.8,
//               textTransform: "uppercase",
//               color: "text.secondary",
//             }}
//           >
//             Schedule
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{ fontWeight: 700, lineHeight: 1.2 }}
//           >
//             Upcoming Interviews
//           </Typography>
//         </Box>
//         {hasEvents && (
//           <Typography
//             variant="caption"
//             color="text.secondary"
//             sx={{ whiteSpace: "nowrap" }}
//           >
//             {events.length} scheduled
//           </Typography>
//         )}
//       </Box>

//       <Divider sx={{ mb: 1.5 }} />

//       {/* Content */}
//       {!hasEvents ? (
//         <Box
//           sx={{
//             py: 3,
//             textAlign: "center",
//             color: "text.secondary",
//             fontSize: 14,
//           }}
//         >
//           No upcoming interviews.
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             flex: 1,
//             overflowY: "auto",
//             maxHeight: { xs: 260, sm: 320, md: 360 },
//           }}
//         >
//           <List dense disablePadding>
//             {events.map((ev) => {
//               const formatted = formatEventDate(ev.start, ev.end);
//               const isRangeString = typeof formatted === "string";

//               return (
//                 <ListItem
//                   key={ev.id}
//                   sx={{
//                     px: 0,
//                     py: 1,
//                     "&:not(:last-of-type)": {
//                       borderBottom: "1px solid",
//                       borderColor: "rgba(229,231,235,0.6)",
//                     },
//                   }}
//                 >
//                   <ListItemText
//                     primary={
//                       <Box
//                         sx={{
//                           display: "flex",
//                           flexDirection: "column",
//                           gap: 0.25,
//                         }}
//                       >
//                         <Typography
//                           variant="body2"
//                           sx={{ fontWeight: 600 }}
//                           noWrap
//                         >
//                           {ev.title}
//                         </Typography>
//                         {ev.candidate && (
//                           <Box
//                             sx={{
//                               display: "inline-flex",
//                               alignItems: "center",
//                               gap: 0.5,
//                               color: "text.secondary",
//                               fontSize: 12,
//                             }}
//                           >
//                             <PersonOutlineIcon sx={{ fontSize: 14 }} />
//                             <span>{ev.candidate}</span>
//                           </Box>
//                         )}
//                       </Box>
//                     }
//                     secondary={
//                       <Box
//                         sx={{
//                           display: "flex",
//                           flexDirection: "column",
//                           gap: 0.25,
//                           mt: 0.5,
//                         }}
//                       >
//                         {isRangeString ? (
//                           <Box
//                             sx={{
//                               display: "inline-flex",
//                               alignItems: "center",
//                               gap: 0.5,
//                               color: "text.secondary",
//                               fontSize: 12,
//                             }}
//                           >
//                             <CalendarMonthIcon sx={{ fontSize: 14 }} />
//                             <span>{formatted}</span>
//                           </Box>
//                         ) : (
//                           <>
//                             <Box
//                               sx={{
//                                 display: "inline-flex",
//                                 alignItems: "center",
//                                 gap: 0.5,
//                                 color: "text.secondary",
//                                 fontSize: 12,
//                               }}
//                             >
//                               <CalendarMonthIcon sx={{ fontSize: 14 }} />
//                               <span>{formatted.dateLabel}</span>
//                             </Box>
//                             <Box
//                               sx={{
//                                 display: "inline-flex",
//                                 alignItems: "center",
//                                 gap: 0.5,
//                                 color: "text.secondary",
//                                 fontSize: 12,
//                               }}
//                             >
//                               <AccessTimeIcon sx={{ fontSize: 14 }} />
//                               <span>{formatted.timeRange}</span>
//                             </Box>
//                           </>
//                         )}
//                       </Box>
//                     }
//                     secondaryTypographyProps={{ component: "div" }}
//                   />
//                 </ListItem>
//               );
//             })}
//           </List>
//         </Box>
//       )}
//     </Paper>
//   );
// }


import React from "react";
import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

export default function InterviewCalendarWidget({ events = [] }) {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const hasEvents = Array.isArray(events) && events.length > 0;

  const formatEventDate = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const sameDay = startDate.toDateString() === endDate.toDateString();

    const dateLabel = startDate.toLocaleDateString(undefined, {
      weekday: "short",
      month: "short",
      day: "numeric",
    });

    if (!sameDay) {
      return `${startDate.toLocaleString()} – ${endDate.toLocaleString()}`;
    }

    const timeRange = `${startDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })} – ${endDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    })}`;

    return { dateLabel, timeRange };
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.75,
        borderRadius: "22px",
        background: dark ? "rgba(13,18,32,0.96)" : "rgba(255,255,255,0.98)",
        border: `1px solid ${border}`,
        boxShadow: dark
          ? "0 20px 50px rgba(0,0,0,0.20)"
          : "0 12px 30px rgba(15,23,42,0.06)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          mb: 1.75,
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: 11,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              color: muted,
              fontWeight: 500,
              fontFamily:
                '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
            }}
          >
            Schedule
          </Typography>

          <Typography
            sx={{
              mt: 0.6,
              fontWeight: 800,
              fontSize: "1.35rem",
              lineHeight: 1.15,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            Upcoming Interviews
          </Typography>
        </Box>

        {hasEvents && (
          <Typography
            sx={{
              fontSize: "12px",
              color: muted,
              whiteSpace: "nowrap",
            }}
          >
            {events.length} scheduled
          </Typography>
        )}
      </Box>

      <Divider sx={{ mb: 1.5, borderColor: border }} />

      {!hasEvents ? (
        <Box
          sx={{
            py: 3,
            textAlign: "center",
            color: mid,
            fontSize: 14,
          }}
        >
          No upcoming interviews.
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            maxHeight: { xs: 260, sm: 320, md: 360 },
          }}
        >
          <List dense disablePadding>
            {events.map((ev) => {
              const formatted = formatEventDate(ev.start, ev.end);
              const isRangeString = typeof formatted === "string";

              return (
                <ListItem
                  key={ev.id}
                  sx={{
                    px: 0,
                    py: 1,
                    "&:not(:last-of-type)": {
                      borderBottom: `1px solid ${border}`,
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.3,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 700,
                            color: text,
                            lineHeight: 1.55,
                          }}
                          noWrap
                        >
                          {ev.title}
                        </Typography>

                        {ev.candidate && (
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 0.5,
                              color: mid,
                              fontSize: 12,
                            }}
                          >
                            <PersonOutlineIcon sx={{ fontSize: 14 }} />
                            <span>{ev.candidate}</span>
                          </Box>
                        )}
                      </Box>
                    }
                    secondary={
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.35,
                          mt: 0.6,
                        }}
                      >
                        {isRangeString ? (
                          <Box
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 0.5,
                              color: mid,
                              fontSize: 12,
                            }}
                          >
                            <CalendarMonthIcon sx={{ fontSize: 14 }} />
                            <span>{formatted}</span>
                          </Box>
                        ) : (
                          <>
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                color: mid,
                                fontSize: 12,
                              }}
                            >
                              <CalendarMonthIcon sx={{ fontSize: 14 }} />
                              <span>{formatted.dateLabel}</span>
                            </Box>

                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 0.5,
                                color: mid,
                                fontSize: 12,
                              }}
                            >
                              <AccessTimeIcon sx={{ fontSize: 14 }} />
                              <span>{formatted.timeRange}</span>
                            </Box>
                          </>
                        )}
                      </Box>
                    }
                    secondaryTypographyProps={{ component: "div" }}
                  />
                </ListItem>
              );
            })}
          </List>
        </Box>
      )}
    </Paper>
  );
}